/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import Loader from '/client/src/components/Loader';
import _ from 'lodash';
import {
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate
} from './utils';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import { withDefaultContext } from './HOC';
import { ActivateStripe } from './loadStripe';
import StripeCard from '/client/src/components/StripeCard/';
import { POST } from '/client/src/api/';

import './styles.scss';
import CssPinner from '/client/src/components/csspinner';

type PropsType = {
  eventId: string | number,
  defaultContext: {
    handleShowSystemDialog: () => void
  }
};

type StatePropsType = {
  event: string,
  number: string,
  name: string,
  expiry: '',
  cvc: string,
  issuer: string,
  focused: string,
  formData: any,
  shippingMethods: [],
  sparxo_stripe_public_key: string,
  shippingMethod: string,
  ticketType: string,
  quantity: string | number,
  streetAddrr: string,
  city: string,
  state: string,
  zipCode: string,
  zipAddr: string,
  addNotes: string
};

class PhysicalTicktetPage extends React.Component<PropsType, StatePropsType> {
  props: PropsType;
  state: StatePropsType;

  static contextType = EventDetailContainerContext;

  constructor(props: PropsType, context: {}) {
    super(props);

    this.state = {
      event: context.eventDetail ? context.eventDetail.name : '',
      number: '',
      name: '',
      expiry: '',
      cvc: '',
      issuer: '',
      focused: '',
      formData: null,
      shippingMethods: [],
      sparxo_stripe_public_key: '',
      shippingMethod: '',
      ticketType: context.eventDetail ? _.get(context, 'eventDetail.tickets[0].id', '') : '',
      quantity: '500',
      streetAddrr: '',
      city: '',
      state: '',
      zipCode: '',
      zipAddr: '',
      addNotes: '',
      isFormValid: true,
      isFormSubmitted: false
    };
  }

  handleLoaded = async (error: Error, response: any) => {
    if (!error) {
      this.setState({
        shippingMethods: _.get(response, 'data.result.shipping_methods', []),
        sparxo_stripe_public_key: _.get(response, 'data.result.sparxo_stripe_public_key', '')
      }, () => {
        if (_.size(this.state.shippingMethods)) {
          this.setState({
            shippingMethod: this.state.shippingMethods[0].amount,
            ticketType: this.context.eventDetail ? this.context.eventDetail.tickets[0].id : ''
          });
        }
      });
    }
  };

  handleInputChange = ({ target }: any) => {
    /* eslint-disable */
    if (target.name === 'number') {
      target.value = formatCreditCardNumber(target.value);
    } else if (target.name === 'expiry') {
      target.value = formatExpirationDate(target.value);
    } else if (target.name === 'cvc') {
      target.value = formatCVC(target.value);
    }

    /* eslint-enable */
    /* eslint-disable camelcase */

    this.setState({ [target.name]: target.value });
  };

  validateForm = (): boolean => {
    const { zipCode, state, zipAddr, streetAddrr, city } = this.state;

    return !(!zipCode || !state || !zipAddr || !streetAddrr || !city);
  }

  handleSubmit = () => {
    this.setState({
      isFormSubmitted: true
    });
    const isFormValid = this.validateForm();

    if (!isFormValid) return;
    document.querySelector('#stripePay').click();
  };

  handleStripSubmit = async (_data: {}) => {
    const modalBody = document.querySelector('.panel-physical-ticket');

    await ActivateStripe({
      publicKey: this.state.sparxo_stripe_public_key
    });

    try {
      const schedule = _.find(_.get(this.context, 'eventDetail.schedules', []), (s: {}): {} => {
        return +s.event_id === +this.props.eventId;
      });

      let _shippingMethod = 'Ups.1Day';

      switch (this.state.shippingMethod) {
        case '9500':
          _shippingMethod = 'Ups.1Day';
          break;
        case '4800':
          _shippingMethod = 'Ups.2Day';
          break;
        case '2500':
          _shippingMethod = 'Ups.5Day';
          break;
        default:
      }


      const data = {
        'bank_card_info': {
          'address_zip': _data.token.card.address_zip,
          // 'card_cvv2': card.cvc,
          'card_expiration_month': _data.token.card.exp_month,
          'card_expiration_year': _data.token.card.exp_year,
          'card_name': _data.token.card.brand,
          'card_number': _data.token.card.last4
        },
        'order': {
          'event_id': this.props.eventId,
          'event_schedule_id': schedule.id,
          'payment_method': 'StripeTokenDirect',
          'shipping_address': {
            'address1': this.state.streetAddrr,
            'city': this.state.city,
            'state': this.state.state,
            'zip_code': this.state.zipCode
          },
          'remark': this.state.addNotes,
          'shipping_method': _shippingMethod,
          'tickets': [
            {
              'quantity': this.state.quantity,
              'id': this.state.ticketType
            }
          ]
        },
        payment_transaction_token: _data.token.id
      };

      console.log(data);

      CssPinner(modalBody, true);

      await POST('/api/v1/1/checkout/physicalticket_order_and_pay', data);

      CssPinner(modalBody, false);

      this.props.defaultContext.handleShowSystemDialog(true, {
        systemDialogType: 'success',
        systemDialogTitle: 'Great!',
        systemDialogContent: 'Successfully'
      });
    } catch (error) {
      console.log(error);
      console.log(_data.error);

      CssPinner(modalBody, false);

      this.props.defaultContext.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Error!',
        systemDialogContent: 'Can\'t order tickets'
      });
    }
  };

  render(): React.Element<'div'> {
    const { eventDetail } = this.context;
    const { shippingMethod, shippingMethods, sparxo_stripe_public_key, isFormSubmitted } = this.state;

    return (
      <div className="panel panel-default panel-page panel-physical-ticket">
        <div className="panel-heading panel-heading-color2">
          <div className="panel-title">
            <span>
              Order Physical Ticket
            </span>
          </div>
        </div>

        <div className="panel-body" style={{ minHeight: '500px' }}>
          <Loader
            url={'/api/v1/1/checkout/physicalticket_order_setting?paymentMethod=StripeTokenDirect'}
            onLoaded={this.handleLoaded}
          >
            <>
              {!!_.size(sparxo_stripe_public_key) &&
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-horizontal">
                        <div className="form-group SimpleInput">
                          <label className="col-xs-3 control-label">Event</label>
                          <div className="col-xs-9">
                            <input
                              name='event'
                              className="form-control"
                              readOnly=""
                              value={eventDetail ? eventDetail.name : ''}
                              onChange={() => { }}
                            />
                          </div>
                        </div>

                        <div className="form-group SimpleInput">
                          <label className="col-xs-3 control-label">Ticket Type</label>
                          <div className="col-xs-9">
                            <select
                              className="form-control"
                              onChange={this.handleInputChange}
                              name='ticketType'
                              value={this.state.ticketType}
                            >
                              { // eslint-disable-next-line
                                _.map(eventDetail ? eventDetail.tickets : [], (t: {}, ti: number): React.Element<'option'> => {
                                  return (
                                    <option key={`${t.id}-${t.name}=${ti}`} value={t.id}>{t.name}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>

                        <div className="form-group SimpleInput">
                          <label className="col-xs-3 control-label">Quantity</label>
                          <div className="col-xs-9">
                            <select
                              className="form-control"
                              onChange={this.handleInputChange}
                              name='quantity'
                              value={this.state.quantity}
                            >
                              <option value="500">500</option>
                              <option value="1000">1000</option>
                              <option value="2000">2000</option>
                              <option value="5000">5000</option>
                              <option value="10000">10000</option>
                            </select>
                          </div>
                        </div>

                        <div className="form-group SimpleInput">
                          <label className="col-xs-3 control-label">Shipping Method</label>
                          <div className="col-xs-9">
                            <select
                              className="form-control"
                              onChange={this.handleInputChange}
                              name='shippingMethod'
                              value={shippingMethod}
                            >
                              {_.map(shippingMethods, (m: {}, mi: number): React.Element<'option'> => {
                                return (
                                  <option
                                    key={`${m.name}=${mi}`}
                                    value={m.amount}
                                  >
                                    {m.description} - ${m.amount / 100}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>

                        <div className="form-group SimpleInput">
                          <label className="col-xs-3 control-label">Postal code</label>
                          <div className="col-xs-9">
                            <input
                              name="zipCode"
                              className={`form-control ${isFormSubmitted && !this.state.zipCode ? 'form-control_error' : ''}`}
                              required
                              onChange={this.handleInputChange}
                              value={this.state.zipCode}
                            />
                            {(isFormSubmitted && !this.state.zipCode) &&
                              <span className="validationMessage">Required field</span>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <div className="payment-card-type" />
                      </div>
                      <div id="PaymentForm" className={`${this.state.ca ? 'card_error' : 0}`}>
                        <StripeCard
                          stripePublicKey={sparxo_stripe_public_key}
                          onHandleSubmit={this.handleStripSubmit}
                        />

                        <div className="form-horizontal">
                          <div className="form-group SimpleInput">
                            <div className="col-xs-12">
                              <input
                                name="zipAddr"
                                placeholder='ZIP'
                                className={`form-control ${isFormSubmitted && !this.state.zipAddr ? 'form-control_error' : ''}`}
                                required
                                onChange={this.handleInputChange}
                                value={this.state.zipAddr}
                              />
                              {isFormSubmitted && !this.state.zipAddr &&
                                <span className="validationMessage">Required field</span>
                              }
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-horizontal">
                        <div className="form-group SimpleInput">
                          <label className="col-xs-3 control-label">State</label>
                          <div className="col-xs-9">
                            <input
                              name="state"
                              className={`form-control ${isFormSubmitted && !this.state.state ? 'form-control_error' : ''}`}
                              required
                              value={this.state.state}
                              onChange={this.handleInputChange}
                            />
                            {isFormSubmitted && !this.state.state && <span className="validationMessage">Required field</span>}
                          </div>
                        </div>
                        <div className="form-group SimpleInput">
                          <label className="col-xs-3 control-label">City</label>
                          <div className="col-xs-9">
                            <input
                              name="city"
                              className={`form-control ${isFormSubmitted && !this.state.city ? 'form-control_error' : ''}`}
                              required
                              value={this.state.city}
                              onChange={this.handleInputChange}
                            />
                            {isFormSubmitted && !this.state.city && <span className="validationMessage">Required field</span>}
                          </div>
                        </div>
                        <div className="form-group SimpleInput">
                          <label className="col-xs-3 control-label">Street Address</label>
                          <div className="col-xs-9">
                            <input
                              name="streetAddrr"
                              className={`form-control ${isFormSubmitted && !this.state.streetAddrr ? 'form-control_error' : ''}`}
                              required
                              value={this.state.streetAddrr}
                              onChange={this.handleInputChange}
                            />
                            {isFormSubmitted && !this.state.streetAddrr && <span className="validationMessage">Required field</span>}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6" />
                  </div>

                  <div className="row">
                    <div className="col-xs-12">
                      <div className="form-group SimpleInput" style={{ height: 'auto' }}>
                        <textarea
                          name='addNotes'
                          className="form-control"
                          rows="6"
                          placeholder="Additional Notes"
                          onChange={this.handleInputChange}
                          value={this.state.addNotes}
                        />
                      </div>
                      <div className="form-group">
                        <div className="pull-right">
                          <button
                            className="btn btn-pink"
                            onClick={this.handleSubmit}
                          >
                            <span>Order Tickets</span> -&nbsp;
                            <span>
                              ${+this.state.quantity + (+this.state.shippingMethod / 100)}
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </>
          </Loader>
        </div>
      </div>
    );
  }
}

export default withDefaultContext(PhysicalTicktetPage);
